import {ref} from 'vue'

/**
 * Auth session state shared across API clients and auth composables.
 * API classes import this module directly to avoid circular import dependencies
 */
export const csrfToken = ref(null)
export const bearerToken = ref(null)
export const isAuthenticated = ref(false)
export const reAuthenticationHandler = ref(null)
